<script>
import {mapActions} from "vuex";
import LoadingSkeleton from "../package/loadingSkeleton.vue"
export default {
  name: "blogCardView",

  data() {
    return {
      blogList: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      isLoading: false
    };
  },
  components:{
    LoadingSkeleton
  },
  methods: {
    ...mapActions("blog", ["getAllBlogPosts"]),
    callbackGetAllBlogPosts(res, type) {
      if (res.data.code === 0 ) {
        console.log(res.data.data.blogPojoList);
        this.blogList = res.data.data.blogPojoList.filter(blog => new Date(blog.publishedOn).getTime() <= Date.now());
        this.totalItems = res.data.data.total;
      }
      this.isLoading = false;
    },
    getPublishedBlogPosts() {
      this.isLoading = true;
      this.getAllBlogPosts({ params: { page: this.currentPage, pageSize: this.pageSize }, callback: this.callbackGetAllBlogPosts });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPublishedBlogPosts();
    },
    truncateHtml(html) {
      // First, strip HTML tags
      const textContent = this.stripHtml(html);
      // Truncate the text if it is longer than 30 characters
      const truncatedText = textContent.length > 200 ? textContent.substring(0, 200) + '...' : textContent;
      return truncatedText;
    },
    stripHtml(html) {
      // Create a new div element and set its innerHTML to the provided HTML string
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      // Use the textContent property to extract plain text without HTML tags
      return tempDiv.textContent || tempDiv.innerText || "";
    },
    redirectToBlog(id) {
      this.$router.push(`/blog/view/${id}`);
    },
    formatDate(dateString) {
      try {
        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
          return 'Invalid Date';
        }

        const year = date.toLocaleDateString('en-US', {
          timeZone: 'Australia/Adelaide',
          year: 'numeric'
        });

        const month = date.toLocaleDateString('en-US', {
          timeZone: 'Australia/Adelaide',
          month: 'long'
        });

        const day = date.toLocaleDateString('en-US', {
          timeZone: 'Australia/Adelaide',
          day: 'numeric'
        });

        return `${day} ${month} ${year}`;
      } catch (error) {
        console.error('Date formatting error:', error);
        return 'Invalid Date Format';
      }
    },
  },
  created() {
    console.log("blog started");
    this.getPublishedBlogPosts();

  },
}
</script>

<template>
  <el-row>
    <el-col :span="21" :offset="2" >
      <div class="container" style="cursor: pointer">
        <template v-if="isLoading">
          <loading-skeleton :loading-text="'Loading...'"/>
        </template>
        <template v-else>
          <div v-if="blogList.length > 0" class="blog-list">
            <!-- Blog Card 1 -->
            <div v-for="blog in blogList" >
              <article class="blog-card" @click="redirectToBlog(blog.id)">
                <div class="blog-image-outer-container">
                  <div class="blog-image-container">
                    <img :src="blog.imageUrl" alt="Blog post" class="blog-image">
                  </div>
                </div>
                <div class="blog-content">
                  <h1 class="blog-title">{{blog.title}}</h1>
                  <p class="blog-excerpt" v-html="truncateHtml(blog.content)">

                  </p>
                  <div class="blog-meta">
                    <time  class="blog-date" :datetime="blog.publishedOn">{{ formatDate(blog.publishedOn) }}</time>
                  </div>
                </div>
              </article>
            </div>
            <el-pagination
              style="display: flex; justify-content: center;"
              background
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              small
              layout="prev, pager, next"
              :total="totalItems">
            </el-pagination>
          </div>
          <div v-else class="empty-blog-list">
            <img src="../../assets/unifi-logo-new.svg" >
          </div>
        </template>


      </div>
    </el-col>
  </el-row>

</template>

<style scoped lang="scss">

.container {
  padding-bottom: 20px;
}

.blog-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 20px;

}
.blog-list::-webkit-scrollbar {
  display: none;
}

.empty-blog-list  {
  height: 500px;
  max-height: 1200px;
  display: flex;
  justify-content: center;
}
.empty-blog-list img {
  width: 25%;
}


.blog-card {
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.blog-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.blog-image-outer-container {
  position: relative;
  height: 400px;
  object-position: top;
  object-fit: cover;
}
.blog-image-container {
  position: relative;
display: inline-block;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.blog-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  vertical-align: top;
}

.blog-content {
  padding: 24px;
}

.blog-category {
  font-size: 14px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 8px;
}

.blog-title {
  font-size: 20px;
  font-weight: 700;
  color: #003333;
  background-color: #ffffff;
  margin-bottom: 12px;
  line-height: 1.3;
}

.blog-excerpt {
  font-size: 16px;
  color: #003333;
  background-color: #ffffff;
  margin-bottom: 16px;
}

.blog-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}

.blog-author {
  display: flex;
  align-items: center;
  gap: 8px;
}

.author-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.author-name {
  font-size: 14px;
  color: #4b5563;
}

.blog-date {
  font-size: 14px;
  color: #003333;
}

.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active {
  background-color: #003333;
  color: #ffffff;
}
.el-pagination.is-background /deep/ .el-pager li:not(.disabled):hover {
  color: #003333;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .blog-image-outer-container {
    height: 150px;
  }
  .blog-title{
    font-size: 15px;
  }
  .blog-excerpt{
     font-size: 12px;
  }
  .blog-date{
    font-size: 12px;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .blog-image-outer-container {
    height: 200px;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .blog-image-outer-container {
    height: 300px;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .blog-image-outer-container {
    height: 400px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/blog/blogCardListView.vue